module.exports = __webpack_public_path__ + "media/images/reclame-aqui-33b89dc3027b856d3c3017214058de5a.png";